/**
 @author xiaoye
 @date 2020/4/10 7:53 下午
 */


import store from '@/store';
import Vue from 'vue'
import {comLegend, comColor} from "../../script/comChart";
import jsonVal from "./json/data.json";

let vm = new Vue();
let vuex = store.state;

export default {
    //类型
    type: 'funnel',
    //类别
    class: 'chart',
    //组件名称
    name: '漏斗图',
    //排序
    sort: 7,
    //是否在多维分析展示
    viewType: true,
    //图标
    iconImg: '/img/loudou.png',
    //基础配置
    option: {
        //最小维度数量
        minWDLength: 1,
        //最小度量数量
        minDLLength: 1,
        //最大维度数量
        maxWDLength: 1,
        //最大度量数量
        maxDLLength: 1,
        //高
        dp_height: 200,
        //宽
        dp_wight: 300,
        //最小高
        dp_min_height: 50,
        //最小宽
        dp_min_wight: 50,
        //是否展示维度配置
        isWdConfig: true,
        //是否展示度量配置
        isDlConfig: true,
        //是否展示JSON配置
        isJSONConfig: true,
        //是否展示公共配置
        isComConfig: true,
        //是否展示边框
        isComBorder: true,
    },
    // 子集展示的配置项
    chilCharts: [
        {
            name: '漏斗图',
            ordImg: '/img/loudou.png',
            bigImg: '/img/loudou.png',
            //默认配置
            chartParam: {},
            //维度配置
            wdParam: {},
            //度量配置
            dlParam: {
                stack: ''
            },
        },
    ],
    //维度组件
    wdComponent: null,
    //维度参数
    wdHandle(option) {
        return {}
    },
    //度量参数
    dlHandle(option) {
        return {}
    },
    //配置参数
    params(option) {
        return {
            //图例配置
            legend: {
                show: true,
                position: 'top',
                //字体
                font: {
                    color: vuex.dpType === 1 ? '#fff' : '#333',
                    size: 14,
                },
                //间隔
                marInterval: 15,
                orient:'horizontal'
            },
            //漏斗配置
            funnel: {
                name: '漏斗图',
                type: 'funnel',
                left: 60,
                top: 60,
                bottom: 60,
                right: 60,
                min: 0,
                max: 10,
                minSize: 1,
                maxSize: 100,
                sort: 'descending',
                funnelAlign: 'center',
                gap: 2,
                labelLine: {
                    length: 10,
                    lineStyle: {
                        width: 1,
                        type: 'solid'
                    }
                },
                label: {
                    show: true,
                    position: 'inside'
                },

                itemStyle: {
                    borderColor: '#fff',
                    borderWidth: 1
                },
                emphasis: {
                    label: {
                        fontSize: 20
                    }
                },

            }

        }
    },
    //配置组件列表
    configModule: [
        {
            name: '图例配置',
            component: () => import('../../comConfig/comLegend/comLegend.vue')
        },
        {
            name: '漏斗配置',
            component: () => import('./config/funnel_config.vue')
        },
    ],
    //接口
    JSONData: {
        //静态数组
        listDaVal: jsonVal,
        //接口参数
        params: {
            //维度
            wd: ['维度'],
            //度量
            dl: ['度量1']
        },
        //引用的组件
        jsonPonent: () => import('./json/json'),
    },
    //静态转换数据回调
    JSONRender(json, chart, nowChart, viewDP) {
        try {
            let setChart = chart.setting;
            let params = nowChart.comParam.JSONData.params;
            let dl = params.dl;
            let wd = params.wd;
            let dlStyParam = setChart.dlStyParam;
            let wdStyParam = setChart.wdStyParam;
            let head = {
                listWD: [],
                listZB: []
            };
            let dt = JSON.parse(json);
            wd.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.wdList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listWD.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comWDConfig)),
                        params: JSON.parse(JSON.stringify(wdStyParam[index] || nowChart.comPonent.wdParams))
                    };
                    data.config.alias = item;
                    setChart.wdList.push(data)
                }
            });
            dl.map((item, index) => {
                if (!item) {
                    return;
                }
                let count = 0;
                for (let i of setChart.dlList) {
                    if (i.name === item) {
                        count = 1;
                        break;
                    }
                }
                head.listZB.push({
                    alias: item,
                    filed: item
                });
                if (count === 0) {
                    let data = {
                        name: item,
                        config: JSON.parse(JSON.stringify(viewDP.comDLConfig)),
                        params: JSON.parse(JSON.stringify(dlStyParam[index] || nowChart.comPonent.dlParams))
                    };
                    data.config.alias = item;
                    setChart.dlList.push(data)
                }
            });
            let JkData = {
                dataTabel: {
                    dt: dt,
                    head: head
                },
                totalCount: dt.length
            };
            chart.data = JkData;
        } catch (e) {
            chart.data = {};
        }
    },
    //切换图表之前的回调
    renderBefore(chart, nowChart, dom) {
        let echart = echarts.init(dom);
        echart.dispose()
        echart = null;
        nowChart.comConfig.gridType = 0;
    },

    //渲染
    rendering(chart, nowChart, dom) {
        // dataAll dt数据  和别名head
        let dataAll = JSON.parse(JSON.stringify(chart.data.dataTabel));
        let config = chart.setting;
        let comConfig = nowChart.comConfig;
        let echart = echarts.init(dom);
        let params = config.params;
        let wdParams = config.wdList;
        let dlParams = config.dlList;
        //维度
        let wd = dataAll.head.listWD;
        //度量
        let dl = dataAll.head.listZB;
        //颜色
        let colorList = JSON.parse(JSON.stringify(comColor(comConfig.colorIndex)));

        //数据 转换成正常格式
        let dataVal = dataAll.dt;
        dataVal.map((item, index) => {
            let da = {};
            for (let i in item) {
                da[i.toLowerCase()] = item[i];
            }
            dataVal[index] = da;
        });

        //
        let legendList = [];

        if (dataAll.dt.length > comConfig.valLength) {
            dataAll.dt.length = nowChart.comConfig.valLength;
        }

        //获取度量数据
        let dlVal = [];
        dl.map((i, index) => {
            let configDL = {};
            dlParams.map((c) => {
                if (c.name === i.filed) {
                    configDL = c;
                }
            });
            dataVal.map((item) => {
                dlVal.push({
                    value: item[i.alias],
                    name: item[wd[0].alias],
                    config: configDL,
                });
                legendList.push(item[wd[0].alias]);
            });
        });


        //获取维度数据
        let wdVal = [];
        dataVal.map((item) => {
            wdVal.push({
                name: item[wd[0].alias]
            })
        });
        let option = {
            tooltip: {
                trigger: 'item',
                formatter: "{a} <br/>{b} : {c}%"
            },
            legend: comLegend(params.legend, legendList),
            color: colorList,
            series: [{
                name: '漏斗图',
                type: 'funnel',
                gap: parseInt(params.funnel.gap || 2),
                left: comConfig.grid.left + "%" || '15%',
                top: comConfig.grid.top + "%" || '5%',
                bottom: comConfig.grid.bottom + "%" || '5%',
                right: comConfig.grid.right + "%" || '5%',
                minSize: params.funnel.minSize + "%" || '10%',
                maxSize: params.funnel.maxSize + "%" || '100%',
                sort: params.funnel.sort || "descending",
                funnelAlign: params.funnel.funnelAlign || "left",
                labelLine: {
                    length: 10,
                    lineStyle: {
                        width: 1,
                        type: 'solid'
                    }
                },
                label: {
                    show: true,
                    position: 'inside'
                },
                itemStyle: {
                    borderColor: '#fff',
                    borderWidth: 1
                },
                emphasis: {
                    label: {
                        fontSize: 20
                    }
                },
                data: dlVal
            }]
        };
        // option.series[0].push(params.funnel)
        echart.clear();
        echart.setOption(option);
        let g_clickTime = null;
        let g_TimeFn = null;
        let g_onItemName = '';
        echart.off('click') //解决重复点击
        echart.on('click', function (params) {
            let myDate = new Date();
            if (g_clickTime === null) {
                g_clickTime = myDate.getMilliseconds();
                g_onItemName = params.name;
                g_TimeFn = setTimeout(function () {
                    window.localStorage.setItem('softContent', params.name) //存值
                    window.localStorage.setItem('softContent1', params.name)
                    echart.setOption(option);
                    xz();
                    g_clickTime = null;
                }, 300);
            } else {
                clearTimeout(g_TimeFn);
                if (Math.abs(myDate.getMilliseconds() - g_clickTime) < 300 && g_onItemName === params.name) {
                    // 双击操作
                    window.localStorage.setItem('dbl', params.name) //存值
                    sz();
                }
                g_clickTime = null;
            }
        });
        echart.resize()
    }
}
